import apiClient from "../../apiClient";
import { ApiResponse } from "../../../types/api";
import {
  BanRequest,
  BanRequestCreate,
  BanRequestUpdate,
  BanRequestApproval,
  GetBanRequestsParams,
} from "./type";
import { Customer } from "../../../types/customer";

export const banRequestsApi = {
  createBanRequest: async (data: BanRequestCreate): Promise<BanRequest> => {
    const response = await apiClient.post<ApiResponse<BanRequest>>(
      "/ban-requests/",
      data,
    );
    return response.data.data;
  },

  listBanRequests: async (
    params: GetBanRequestsParams = {},
  ): Promise<BanRequest[]> => {
    const queryParams = new URLSearchParams();

    if (params.skip !== undefined)
      queryParams.append("skip", params.skip.toString());
    if (params.limit !== undefined)
      queryParams.append("limit", params.limit.toString());
    if (params.status) queryParams.append("status", params.status);
    if (params.customerId) queryParams.append("customer_id", params.customerId);

    const response = await apiClient.get<ApiResponse<BanRequest[]>>(
      `/ban-requests/?${queryParams.toString()}`,
    );
    return response.data.data;
  },

  getBanRequest: async (banRequestId: string): Promise<BanRequest> => {
    const response = await apiClient.get<ApiResponse<BanRequest>>(
      `/ban-requests/${banRequestId}`,
    );
    return response.data.data;
  },

  updateBanRequest: async (
    banRequestId: string,
    data: BanRequestUpdate,
  ): Promise<BanRequest> => {
    const response = await apiClient.put<ApiResponse<BanRequest>>(
      `/ban-requests/${banRequestId}`,
      data,
    );
    return response.data.data;
  },

  approveBanRequest: async (banRequestId: string): Promise<BanRequest> => {
    const response = await apiClient.put<ApiResponse<BanRequest>>(
      `/ban-requests/${banRequestId}/approve`,
      {},
    );
    return response.data.data;
  },

  rejectBanRequest: async (
    banRequestId: string,
    data: BanRequestApproval,
  ): Promise<BanRequest> => {
    const response = await apiClient.put<ApiResponse<BanRequest>>(
      `/ban-requests/${banRequestId}/reject`,
      data,
    );
    return response.data.data;
  },

  deleteBanRequest: async (banRequestId: string): Promise<void> => {
    await apiClient.delete(`/ban-requests/${banRequestId}`);
  },

  getCustomerBanHistory: async (customerId: string): Promise<BanRequest[]> => {
    const response = await apiClient.get<ApiResponse<BanRequest[]>>(
      `/ban-requests/customers/${customerId}/history`,
    );
    return response.data.data;
  },

  unbanCustomer: async (customerId: string): Promise<Customer> => {
    const response = await apiClient.put<ApiResponse<Customer>>(
      `/ban-requests/customers/${customerId}/unban`,
      {},
    );
    return response.data.data;
  },
};
